import { render, staticRenderFns } from "./ForwardMessageDialog.vue?vue&type=template&id=64f0d86b&scoped=true"
import script from "./ForwardMessageDialog.vue?vue&type=script&lang=js"
export * from "./ForwardMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./ForwardMessageDialog.vue?vue&type=style&index=0&id=64f0d86b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f0d86b",
  null
  
)

export default component.exports